<app-pop-up>
    <app-pop-up-header class="header" [headerName]="'Are you sure?'" (close)="cancel()"></app-pop-up-header>
    <div class="message-text">
        <span>{{message}}</span>
    </div>
    <app-pop-up-footer>
      <app-button [name]="'CANCEL'" [type]="'outlined'" (btnClick)="cancel()"></app-button>
      <app-button [name]="'DELETE'" [type]="'delete-confirm'" (btnClick)="delete()"></app-button>
    </app-pop-up-footer>
</app-pop-up>
